// !!!!
// This is a generated file.
// Do not manually change this file
// !!!!

export const MO_Confirmation_Type = {
    MO_Confirmation: 2032730112,
    Manufacturing_Mobile: 2032730113,
    Data_Collection: 2032730114,
};
